import { SERVICE_NAME } from "@/config/serviceNames";
import { EntityType, Module } from "@/constants";
import { requests } from ".";

interface resetBody {
  companyId?: string;
  isEmailVerified?: boolean;
  isPhoneVerified?: boolean;
  releasePhoneLock?: string;
}

const OnboardingService = {
  fetchEmailVerificationCode: (emailId: string) =>
    requests(SERVICE_NAME.ONBOARDING_API).get(
      `verification-code/email/${emailId}`
    ),

  fetchPhoneVerificationCode: (phoneNo: string) =>
    requests(SERVICE_NAME.ONBOARDING_API).get(
      `verification-code/phone/${phoneNo}`
    ),

  resetVerification: (body: resetBody) =>
    requests(SERVICE_NAME.ONBOARDING_API)
      .log({
        module: Module.ONBOARDING,
        entityType: EntityType.COMPANY,
        entityId: body?.companyId ?? body?.releasePhoneLock ?? "UNKNOWN",
      })
      .put(`reset`, body),

  fetchReleasePhoneLogs: (phoneNo: string) =>
    requests(SERVICE_NAME.ONBOARDING_API).get(`reset/release-phone/${phoneNo}`),

  fetchEmailVerificationStatus: (companyId: string) =>
    requests(SERVICE_NAME.ONBOARDING_API).get(
      `verify/status?companyId=${companyId}`
    ),
};

export default OnboardingService;
